import { Animal } from "src/app/api/models";
import { AppointmentHelper } from "./appointment.helper";

export class AnimalHelper {

    static sortAnimals(animals: Array<Animal>): Array<Animal> {
    const customerAnimals = animals.sort(animal => {
      if (animal.isAlive) {
        return -1;
      } else {
        return 1;
      }
    });
    let uniqueAnimalsObj: Record<string, Animal> = {};

    [...customerAnimals].forEach(a => {
      if (a.animalId) {
        uniqueAnimalsObj[a?.animalId] = a;
      }
    });
    return AppointmentHelper.sortAnimalsAsc(uniqueAnimalsObj);
  }

  /**
   * Pads zeros after the first two letters to make the total length `totalLen`.
   * Example: "AT2292374287" -> "AT002292374287" (total length 14)
   */
  static formatTvdNumber(input: string | undefined): string | undefined {
    if (!input) {
      return input;
    }
    const totalLen = 14;

    // Expect exactly 2 letters followed by digits
    const match = input.trim().match(/^([A-Za-z]{2})(\d+)$/);
    if (!match) {
      return input;
    }

    const [, prefix, numeric] = match;
    const currentLen = prefix.length + numeric.length;
    const zerosNeeded = totalLen - currentLen;

    if (zerosNeeded < 0) {
      // If the value is already longer than totalLen, return as-is or handle per your needs.
      // You could also choose to throw an error here.
      return input;
    }

    return `${prefix}${'0'.repeat(zerosNeeded)}${numeric}`;
  }

}
